//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import PasswordInput from "@Shared/components/inputs/password-input.vue";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { postAccountsApi } from "@Shared/@Utils/ajax";
import { showToast } from "@Shared/@Utils/constants";
import Err from "@Broker/@Routes/error";
import { sameAsWithLabel, validPassword } from "@Shared/@Utils/validation-rules";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PasswordVerify",
  components: {
    MaterialInput,
    PasswordInput,
    SimpleButton,
    InlineLoader
  },
  mixins: [validationMixin],
  validations: {
    code: {
      required,
      maxLength: maxLength(6)
    },
    password: {
      required,
      validPassword
    },
    passwordRepeat: {
      required,
      sameAs: sameAsWithLabel("Password above")("password")
    },
    email: {
      required
    }
  },
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      code: "",
      resendingCode: false,
      loading: false,
      loadingStatus: true,
      password: "",
      passwordRepeat: ""
    };
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    }
  },
  methods: {
    async resendCode() {
      if (this.resendingCode) return;
      try {
        this.resendingCode = true;
        await postAccountsApi({
          email: this.email
        }, "/reset-password");
        showToast("success", "codeSentCheckEmail");
      } catch (e) {
        Err.handle(e);
      } finally {
        this.resendingCode = false;
      }
    },
    async handleSubmit() {
      if (!this.isValid) return;
      try {
        this.loading = true;
        await postAccountsApi({
          email: this.email,
          password: this.password,
          verificationCode: this.code
        }, "/update-reset-password");
        this.loadingStatus = true;
        this.loading = false;
        this.$emit("next-page", {
          page: "password-set"
        });
      } catch (e) {
        this.loadingStatus = false;
        this.loading = false;
        Err.handle(e);
      }
    }
  }
});